export enum UserActionTypeRetentionPolicyChanged {
  AddedRetentionPolicy = 'AddedRetentionPolicy',
  AssignedRetentionPolicy = 'AssignedRetentionPolicy',
  DeletedRetentionPolicy = 'DeletedRetentionPolicy',
  EditedArtifactRetentionPolicy = 'EditedArtifactRetentionPolicy',
  EditedRetentionPolicy = 'EditedRetentionPolicy'
}
